import configService from "@/services/config";
import { askIQStream } from "@/api/askIQApi";
import {
  buildIqSuggestQuizEndpoint,
  buildSuggestQuizPayload,
} from "@/utils/buildSuggestQuizPayload";

/**
 * Stream quiz suggestions from IQ POST /suggest-quiz/.
 * @param {Object} params
 * @param {string} params.checkpointCriteria
 * @param {string} params.microlearningContent
 * @param {string[]} [params.existingQuestions]
 * @param {number} params.remainingSlots
 * @param {AbortSignal} [params.signal]
 * @param {Function} [params.onThinkingUpdate]
 * @param {Function} [params.onComplete]
 * @returns {Promise<{ data: Object }>}
 */
export async function suggestQuizStream({
  checkpointCriteria,
  microlearningContent,
  existingQuestions = [],
  remainingSlots,
  signal,
  onThinkingUpdate,
  onComplete,
}) {
  const iqBaseUrl = configService.get("iqBaseUrl");
  const customEndpoint = buildIqSuggestQuizEndpoint(iqBaseUrl);
  const customPayload = buildSuggestQuizPayload({
    checkpointCriteria,
    microlearningContent,
    existingQuestions,
    remainingSlots,
  });

  return askIQStream({
    question: "",
    customEndpoint,
    customPayload,
    signal,
    onThinkingUpdate,
    onComplete,
  });
}
